"use client";
import {
  useHovercard
} from "../__chunks/AJE6WNNP.js";
import "../__chunks/X7QOZUD3.js";
import "../__chunks/RR3QLTVJ.js";
import {
  createDialogComponent
} from "../__chunks/U7BJ2WVN.js";
import "../__chunks/4CA6HQZC.js";
import "../__chunks/NSFBIL2Z.js";
import "../__chunks/ESSM74HH.js";
import "../__chunks/SEMTJMZO.js";
import "../__chunks/R7AVCKGB.js";
import "../__chunks/LNYYGYYJ.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/2PGBN2Y4.js";
import "../__chunks/63XF7ACK.js";
import "../__chunks/AOUGVQZ3.js";
import "../__chunks/K2ZF5NU7.js";
import "../__chunks/FQDOBJ6H.js";
import "../__chunks/56RR3YNE.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/HZ7KGUEF.js";
import "../__chunks/U7IXCFEO.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/WOYVW654.js";
import "../__chunks/4KVV4LMJ.js";
import {
  TooltipScopedContextProvider,
  useTooltipProviderContext
} from "../__chunks/V3XGKTI7.js";
import "../__chunks/BEBUB5QN.js";
import "../__chunks/M6ZUVZPG.js";
import "../__chunks/32IPIQBR.js";
import "../__chunks/EQMNTDLB.js";
import "../__chunks/DRL2GNLJ.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/KXBJFI2T.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/PTCNA5XT.js";
import "../__chunks/XRRE3XFB.js";
import "../__chunks/TUWQEMG5.js";
import "../__chunks/FQ77EHUR.js";
import {
  useWrapElement
} from "../__chunks/WX6L4ACS.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip.tsx
import { contains } from "@ariakit/core/utils/dom";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useTooltip = createHook(
  function useTooltip2(_a) {
    var _b = _a, {
      store,
      portal = true,
      gutter = 8,
      preserveTabOrder = false,
      hideOnHoverOutside = true,
      hideOnInteractOutside = true
    } = _b, props = __objRest(_b, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const context = useTooltipProviderContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(TooltipScopedContextProvider, { value: store, children: element }),
      [store]
    );
    const role = store.useState(
      (state) => state.type === "description" ? "tooltip" : "none"
    );
    props = __spreadValues({ role }, props);
    props = useHovercard(__spreadProps(__spreadValues({}, props), {
      store,
      portal,
      gutter,
      preserveTabOrder,
      hideOnHoverOutside(event) {
        if (isFalsyBooleanCallback(hideOnHoverOutside, event)) return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement) return true;
        if ("focusVisible" in anchorElement.dataset) return false;
        return true;
      },
      hideOnInteractOutside: (event) => {
        if (isFalsyBooleanCallback(hideOnInteractOutside, event)) return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement) return true;
        if (contains(anchorElement, event.target)) return false;
        return true;
      }
    }));
    return props;
  }
);
var Tooltip = createDialogComponent(
  forwardRef(function Tooltip2(props) {
    const htmlProps = useTooltip(props);
    return createElement(TagName, htmlProps);
  }),
  useTooltipProviderContext
);
export {
  Tooltip,
  useTooltip
};
